module.exports = {
    color: {
        primary: "#00aed6",
        secondary: "#3f4e53",
        grey: "#a6a6a6",
        greyLight: "#eee",
        black: "#343935",
        white: "#ffffff",
        maxWidth: "1140px"
    },
    spacing: {
        containerWidth: "1000px"
    }
};



// WEBPACK FOOTER //
// ./src/styles/theme.js